import { Box, Typography } from '@mui/material';
import React from 'react';
import MdViewer from '../markdown/MdViewer';
import { BriefSection } from '../types';

export interface BriefingProps {
  sections: BriefSection[];
}

const Briefing = ({ sections }: BriefingProps) => (
  <>
    {sections.map((section, i) =>
      section.type === 'section' ? (
        <Box key={i} sx={{ mb: 4 }}>
          <Typography component="h3" variant="h6" gutterBottom>
            {section.title}
          </Typography>
          <MdViewer text={section.text}></MdViewer>
        </Box>
      ) : (
        <Box key={i} component="img" src={section.url} sx={{ maxWidth: '100%', mb: 4 }} />
      ),
    )}
  </>
);

export default Briefing;
